import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ExternalLinkClass;
function ExternalLink() {
  if (ExternalLinkClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.lba(this.qb6_1.abf(ClickableSemantic_getInstance()));
        this.vb5_1.zb3_1 = 'a';
        this.vb5_1.jb4_1.v('kiteui-stack');
        this.vb5_1.jb4_1.v('clickable');
      }
      wb9(index, view) {
        super.wb9(index, view);
        Companion_instance.nbg(this, index, view);
      }
    }
    initMetadataForClass($, 'ExternalLink');
    ExternalLinkClass = $;
  }
  return ExternalLinkClass;
}
//region block: exports
export {
  ExternalLink as ExternalLink3fl954ixvn5zt,
};
//endregion

//# sourceMappingURL=ExternalLink.commonHtml.mjs.map
